<template>
    <div id="attachment">
        <el-row>
            <span>图片:</span>
            <div style="border:1px dashed #000; width:250px; height:250px; text-align:center" v-if="attachmentInfo.pic!=''">
                <img :src="'/api/static'+attachmentInfo.pic" alt="" style="margin: 0 auto; width:250px; height:250px;" @click="showPic=true">
            </div>
            <span v-if="attachmentInfo.pic==''">无</span>
        </el-row>
        <el-row>
            <span>附件:</span>
            <a :download="orderId+'_附件.rar'" :href="'/api/static'+attachmentInfo.zip" v-if="attachmentInfo.zip!=''">附件下载</a>
            <span v-if="attachmentInfo.zip==''">无</span>
        </el-row>
        <el-dialog :visible.sync="showPic" append-to-body>
            <img width="100%" :src="'/api/static'+attachmentInfo.pic">
        </el-dialog>
    </div>
</template>
<script>
export default {
    data: function(){
        return {
            showPic:false
        }
    },
    props: {
        attachmentInfo: {},
        orderId: String
    }
}
</script>




// WEBPACK FOOTER //
// src/components/production/Attachment.vue